module.exports = __webpack_public_path__ + "c697c51f952d22807ee72cb3436c8a4c.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/virtual-sports/assets/vfc.png
// module id = 1780
// module chunks = 2